// Zones défilantes de « Mon compte ».
//
// Trois zones de cette page défilent horizontalement : le menu du compte devenu rangée
// d'onglets sous 768px, les onglets de « Utiliser mes points », et le tableau des transactions.
// Toutes trois masquent leur ascenseur — de toute façon en surimpression sur mobile — et rien
// ne dirait donc qu'il y a une suite. Ce fichier s'en charge : il dit de quel côté il reste
// quelque chose à voir, et il ouvre les rangées d'onglets sur l'onglet courant.
//
// Le fondu lui-même est en CSS, par un masque piloté par les deux classes posées ici
// (src/sass/_mon_compte.scss, mixin « voile-de-suite »).

// Chaque zone, avec l'élément à recentrer à l'ouverture s'il y en a un. Le tableau n'a pas
// d'élément courant : on se contente d'y poser le voile.
var ZONES = [
    { zone: '.woocommerce-MyAccount-navigation .list-group', courant: '.list-group-item.active' },
    { zone: '.wlr-user-reward-titles', courant: '.wlr-my-rewards-title.active' },
    { zone: '#wlr-transaction-table', courant: null }
];

// Tolérance sur les comparaisons de défilement : scrollLeft est fractionnaire dès que la page
// est zoomée ou que l'écran a un rapport de pixels non entier, et une comparaison stricte
// laisserait le voile allumé d'un pixel en butée.
var MARGE = 2;


// On lit le défilement réel plutôt que de poser un fondu des deux côtés en permanence : un
// voile à gauche alors qu'on est déjà au début annoncerait une suite qui n'existe pas.
function majVoilesCompte(zone) {

    var defilable = zone.scrollWidth - zone.clientWidth > MARGE;

    zone.classList.toggle('is-defilable-debut', defilable && zone.scrollLeft > MARGE);
    zone.classList.toggle('is-defilable-fin', defilable && zone.scrollLeft + zone.clientWidth < zone.scrollWidth - MARGE);
}


// L'onglet courant peut naître hors de l'écran : dans le menu du compte, « Points de fidélité &
// Récompenses » est le sixième des sept et commence à plus de 1800px du bord à 390px de large.
// Sans ceci, la cliente arrive sur une rangée qui ne dit pas où elle est.
//
// On écrit scrollLeft sur la zone plutôt que d'appeler scrollIntoView() sur l'onglet : sur un
// conteneur défilant imbriqué, scrollIntoView fait aussi défiler le document, et la page
// s'ouvrirait quelques dizaines de pixels plus bas qu'elle ne devrait.
//
// Le décalage se calcule à partir des rectangles, et NON de offsetLeft : celui-ci se mesure
// depuis l'ancêtre positionné, qui n'est pas la zone défilante. Sur les onglets de récompenses,
// qui vivent dans une colonne décalée, l'écart atteignait 266px et la rangée s'ouvrait en butée
// au lieu de se centrer ; sur le menu du compte il valait 12px, assez peu pour passer inaperçu.
// Rendre la zone « position: relative » corrigerait aussi le symptôme, mais ferait dépendre le
// script d'une propriété de mise en page qu'il ne contrôle pas.
function recentrerCourantCompte(zone, selecteurCourant) {

    if (!selecteurCourant) {
        return;
    }

    var courant = zone.querySelector(selecteurCourant);

    if (!courant) {
        return;
    }

    var decalage = courant.getBoundingClientRect().left - zone.getBoundingClientRect().left + zone.scrollLeft;

    zone.scrollLeft = decalage - (zone.clientWidth - courant.offsetWidth) / 2;
}


function initialiserZonesCompte() {

    var zones = [];

    ZONES.forEach(function (description) {

        var zone = document.querySelector(description.zone);

        if (!zone) {
            return;
        }

        zones.push(zone);

        recentrerCourantCompte(zone, description.courant);
        majVoilesCompte(zone);

        // passive : on ne fait que lire le défilement, on ne le bloque jamais. Sans ce drapeau
        // le navigateur doit attendre le retour du gestionnaire avant de faire glisser la zone.
        zone.addEventListener('scroll', function () {
            majVoilesCompte(zone);
        }, { passive: true });
    });

    if (!zones.length) {
        return;
    }

    // La rotation d'un téléphone change la largeur visible, donc les côtés défilables. Au-dessus
    // de 768px le menu redevient une liste verticale : scrollWidth y vaut clientWidth, les deux
    // classes tombent d'elles-mêmes et le masque redevient franc.
    window.addEventListener('resize', function () {
        zones.forEach(majVoilesCompte);
    });
}


// On ne se contente pas d'écouter DOMContentLoaded : la feuille du thème est chargée en pied
// de page, donc avant cet événement aujourd'hui — mais il suffirait qu'une extension
// d'optimisation ajoute un defer sur le script pour qu'il s'exécute APRÈS, et l'écouteur ne
// serait jamais appelé. On teste donc l'état du document, et on agit tout de suite s'il est
// déjà prêt.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiserZonesCompte);
} else {
    initialiserZonesCompte();
}
